const commonReducer = (state = {}, action) => {
  switch (action.type) {
    case "MENU_TOGGLE":
      return Object.assign({}, state, {
        menuToggle: action.data,
      });
    case "SIDE_PANEL":
      return Object.assign({}, state, {
        sidePanel: action.data,
      });
    case "HISTORY_LOG":
      return Object.assign({}, state, {
        historyLog: action.data,
      });
    case "SHOW_LOADER":
      return Object.assign({}, state, {
        loading: action.data,
      });
    case "SETTINGS":
      return Object.assign({}, state, {
        settings: action.data,
      });
    case "WEIGHT_CALCULATION":
      return Object.assign({}, state, {
        weight: action.data,
      });
    case "SD":
      return Object.assign({}, state, {
        addNewSd: action.data,
      });
    case "CANCEL":
      return Object.assign({}, state, {
        alertCancel: action.data,
      });
    case "RICHTEXT_CANCEL":
      return Object.assign({}, state, {
        richtextCancel: action.data,
      });
    case "RICHTEXT":
      return Object.assign({}, state, {
        richtext: action.data,
      });
    case "RICHTEXT_CANCEL1":
      return Object.assign({}, state, {
        richtextCancel1: action.data,
      });
    case "RICHTEXT1":
      return Object.assign({}, state, {
        richtext1: action.data,
      });    
     
    default:
      return state;
  }
};

export default commonReducer;